import CloseButton from "../CloseButton";
import "./style.css";

function CustomSlider({ showCloseButton = true, show, setShowSlider, children }) {
    return (
        <div id="custom-slider" style={{ top: show ? "0" : "100%" }}>
            {(showCloseButton && setShowSlider) && <CloseButton onClick={() => {
                setShowSlider(false);
            }} />}
            {children}
        </div>
    );
}

export default CustomSlider;
